module.exports = __webpack_public_path__ + "static/img/jp0.ed428f3f.png";